export default {
  ENT_TOURNAMENT_STATUS_CHANGED: 'statusChanged',
}
